import { render, staticRenderFns } from "./VxTooltip.vue?vue&type=template&id=35b97e18"
import script from "./VxTooltip.vue?vue&type=script&lang=js"
export * from "./VxTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/alquant/white-label-platforms/platform-hexagon-capital/platform/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b97e18')) {
      api.createRecord('35b97e18', component.options)
    } else {
      api.reload('35b97e18', component.options)
    }
    module.hot.accept("./VxTooltip.vue?vue&type=template&id=35b97e18", function () {
      api.rerender('35b97e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vx-tooltip/VxTooltip.vue"
export default component.exports